module.exports = __webpack_public_path__ + "78f97cc2096690138b341b609cf269d2.png";